import * as React from 'react';
import {renderReact} from 'hypernova-react';
import {I18nContext, I18nManager} from '@shopify/react-i18n';
import {Listing} from './Listing';

const manager = new I18nManager({locale: 'en-CA'});

export function ListingSection(props) {
  return (
    <I18nContext.Provider value={manager}>
      <Listing {...props} />
    </I18nContext.Provider>
  );
}

export default renderReact('Listing', ListingSection);
export * from './components';
